import { apiRequest } from '../http'

// 获取闪卡词汇资源
export const getFreePracticeResource = (params) => apiRequest.post('/word/practice/getWordResource',params)

// 保存闪卡练习结果
export const saveFlashcardRecord = (params) => apiRequest.post('/word/practice/submit', params)

// 获取选择题的错误选项
export const getSelectOptions = (params) => apiRequest.get('word/practice/getSelectionOption', {params})

// 句子分析
export const analyseSentence = (params) => apiRequest.post('/word/practice/analyse', params)